<template>
  <div
    class="mx-3 mb-2 text-gray-brand-700 text-sm"
    v-if="
      protein ||
      totalFat ||
      totalCarbs ||
      calories ||
      addedSugar ||
      cholesterol ||
      dietaryFiber ||
      iron ||
      saturatedFat ||
      sodium ||
      sugars ||
      transFat ||
      vitaminC ||
      vitaminD
    "
  >
    <div v-if="nutritionalInformation?.servings_per_container ?? 1 !== 1" class="italic">
      Nutritional information per serving (contains
      {{ nutritionalInformation?.servings_per_container }} servings)
    </div>
    <div class="flex flex-wrap gap-x-2">
      <div v-if="calories">
        <span class="font-semibold">{{ calories }}</span>
        <span class="ml-1">Calorie{{ calories === 1 ? '' : 's' }}</span>
      </div>
      <div v-if="totalFat">
        <span class="font-semibold">{{ totalFat }}g</span>
        <span class="ml-1 hidden lg:inline">Total</span>
        <span class="ml-1">Fats</span>
      </div>
      <div v-if="totalCarbs">
        <span class="font-semibold">{{ totalCarbs }}g</span>
        <span class="ml-1 hidden lg:inline">Total</span>
        <span class="ml-1">Carbs</span>
      </div>
      <div v-if="protein">
        <span class="font-semibold">{{ protein }}g</span>
        <span class="ml-1">Protein</span>
      </div>
      <div v-if="addedSugar">
        <span class="font-semibold">{{ addedSugar }}g</span>
        <span class="ml-1">Added Sugar</span>
      </div>
      <div v-if="cholesterol">
        <span class="font-semibold">{{ cholesterol }}mg</span>
        <span class="ml-1">Cholesterol</span>
      </div>
      <div v-if="dietaryFiber">
        <span class="font-semibold">{{ dietaryFiber }}g</span>
        <span class="ml-1">Dietary Fiber</span>
      </div>
      <div v-if="iron">
        <span class="font-semibold">{{ iron }}mg</span>
        <span class="ml-1">Iron</span>
      </div>
      <div v-if="saturatedFat">
        <span class="font-semibold">{{ saturatedFat }}g</span>
        <span class="ml-1">Saturated Fat</span>
      </div>
      <div v-if="sodium">
        <span class="font-semibold">{{ sodium }}mg</span>
        <span class="ml-1">Sodium</span>
      </div>
      <div v-if="sugars">
        <span class="font-semibold">{{ sugars }}g</span>
        <span class="ml-1">Sugars</span>
      </div>
      <div v-if="transFat">
        <span class="font-semibold">{{ transFat }}g</span>
        <span class="ml-1">Trans Fat</span>
      </div>
      <div v-if="vitaminC">
        <span class="font-semibold">{{ vitaminC }}mg</span>
        <span class="ml-1">Vitamin C</span>
      </div>
      <div v-if="vitaminD">
        <span class="font-semibold">{{ vitaminD }}mcg</span>
        <span class="ml-1">Vitamin D</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductNutritionalInformation',
  props: {
    nutritionalInformation: {
      type: Object,
      required: true
    }
  },
  computed: {
    protein() {
      return this.nutritionalInformation?.protein
    },
    calories() {
      return this.nutritionalInformation?.calories
    },
    totalFat() {
      return this.nutritionalInformation?.total_fat
    },
    totalCarbs() {
      return this.nutritionalInformation?.total_carbs
    },
    addedSugar() {
      return this.nutritionalInformation?.added_sugar
    },
    cholesterol() {
      return this.nutritionalInformation?.cholesterol
    },
    dietaryFiber() {
      return this.nutritionalInformation?.dietary_fiber
    },
    iron() {
      return this.nutritionalInformation?.iron
    },
    saturatedFat() {
      return this.nutritionalInformation?.saturated_fat
    },
    sodium() {
      return this.nutritionalInformation?.sodium
    },
    sugars() {
      return this.nutritionalInformation?.sugars
    },
    transFat() {
      return this.nutritionalInformation?.trans_fat
    },
    vitaminC() {
      return this.nutritionalInformation?.vitamin_c
    },
    vitaminD() {
      return this.nutritionalInformation?.vitamin_d
    }
  }
}
</script>
